import { Component, OnInit } from '@angular/core';
import { AlertModel, ALERT_TYPE } from '../shared/alert/alert.component';
import { SessionStorageService } from 'src/app/auth/services/session.service';
import { ConsultaTransaccionService } from '../../services/consultaTransaccion/consultaTransaccion.service';

declare var $: any;

@Component({
  selector: 'app-consulta-transaccion',
  templateUrl: './consultaTransaccion.component.html',
  styleUrls: ['./consultaTransaccion.component.css']
})
export class ConsultaTransaccionComponent implements OnInit {

  public title: string = "CONSULTA DE TRANSACCIÓN (JSON)";
  public loading: boolean = false;
  public alertMessage: AlertModel = new AlertModel;
  public alertConfirmEvent: Function;

  public cuil: string = "";
  public pcn: string = "";
  public fecha: string = "";
  public showResult: boolean = false;
  public tableResult: any[] = [];
  public consultaFecha: string = "";
  public selectedItem: any = null;

  constructor(
    private consultaTransaccionService: ConsultaTransaccionService,
    private sessionStorageService: SessionStorageService
  ) {
    if (!this.sessionStorageService.hasRolesUser(["AMX_ADMIN"])) {
      this.sessionStorageService.redirectToLogin();
    }
  }

  ngOnInit() {
  }

  consultar() {
    if ((!this.cuil || this.cuil.trim() === '') && (!this.pcn || this.pcn.trim() === '')) {
      this.alertMessage = new AlertModel("Debe ingresar un CUIL o un PCN.", this.title, true, "WARNING");
      return;
    }

    this.loading = true;
    this.showResult = false;
    this.tableResult = [];
    this.selectedItem = null;

    let request = {
      "cuil": this.cuil.trim(),
      "pcn": this.pcn.trim(),
      "fecha": this.fecha || ""
    };

    this.consultaTransaccionService.searchLogExternal(request).subscribe(
      data => {
        if (data && data['code'] == '0') {
          this.tableResult = data['data'].map((item: any) => ({ ...item, expanded: false, showRequest: false, showResponse: false }));
          this.showResult = true;
          this.consultaFecha = this.formatDateTime(new Date());
        } else {
          let msg = data['message'] || "No se encontraron registros.";
          this.alertMessage = new AlertModel(msg, this.title, true, ALERT_TYPE.WARNING);
        }
        this.loading = false;
      },
      error => {
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al consultar.", this.title, true, ALERT_TYPE.ERROR);
        this.loading = false;
      }
    );
  }

  verDetalle(item: any) {
    this.selectedItem = item;
  }

  toggleDetalle(index: number) {
    this.tableResult[index].expanded = !this.tableResult[index].expanded;
    this.selectedItem = this.tableResult[index].expanded ? this.tableResult[index] : null;
    // al colapsar la fila, se cierran tambien sus paneles internos
    if (!this.tableResult[index].expanded) {
      this.tableResult[index].showRequest = false;
      this.tableResult[index].showResponse = false;
    }
  }

  toggleRequest(index: number) {
    this.tableResult[index].showRequest = !this.tableResult[index].showRequest;
  }

  toggleResponse(index: number) {
    this.tableResult[index].showResponse = !this.tableResult[index].showResponse;
  }

  cerrarDetalle() {
    this.selectedItem = null;
  }

  formatDateTime(date: Date): string {
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return day + '/' + month + '/' + year + ', ' + hours + ':' + minutes + ':' + seconds;
  }

  formatJson(jsonStr: string): string {
    if (!jsonStr) return '';
    try {
      let obj = JSON.parse(jsonStr);
      return JSON.stringify(obj, null, 2);
    } catch (e) {
      return jsonStr;
    }
  }

  limpiar() {
    this.cuil = "";
    this.pcn = "";
    this.fecha = "";
    this.showResult = false;
    this.tableResult = [];
    this.selectedItem = null;
  }

  exportarTxt() {
    if (!this.selectedItem) return;
    let content = "PCN: " + this.selectedItem.pcn + "\n\n";
    content += "Request:\n" + this.formatJson(this.selectedItem.request) + "\n\n";
    content += "Response:\n" + this.formatJson(this.selectedItem.response);
    let blob = new Blob([content], { type: 'text/plain' });
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = 'transaccion_' + (this.selectedItem.pcn || 'log') + '.txt';
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
